// extracted by mini-css-extract-plugin
export default {"LazilyAddInput":"LazilyAddInput_LazilyAddInput__u0v3X","button":"LazilyAddInput_button__QuRUC"};